import { render, staticRenderFns } from "./onValu.vue?vue&type=template&id=5f002dc5"
import script from "./onValu.vue?vue&type=script&lang=js"
export * from "./onValu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports